import { Component, Input } from '@angular/core';
import { FormsModule, ReactiveFormsModule, UntypedFormGroup } from '@angular/forms';
import { CellTemplateDirective, ColumnComponent, GridComponent, KENDO_GRID } from '@progress/kendo-angular-grid';
import { ClientServices } from '../../../@theme/services/clients.service';
@Component({
    selector: 'gd-grid',
    template: `
    <div [formGroup]="form" style="">
      <!-- style="float:right; margin-right:50px; width:70%" -->
      <kendo-grid
        #grid
        [data]="field.gridValues"
        [height]="60"
        style="font-size:10px; width:80%"
        [pageable]="false"
        [resizable]="true"
        [filterable]="false"
        [sortable]="false"
        [selectable]="false"
        name="field.name"
        [navigable]="false"
      >
        <kendo-grid-column
          field="equitiesExp"
          title="Equities"
        ></kendo-grid-column>
        <kendo-grid-column
          field="optionsExp"
          title="Options"
        ></kendo-grid-column>
        <kendo-grid-column
          field="fixedIncExp"
          title="Fixed Income"
        ></kendo-grid-column>
        <kendo-grid-column
          field="mutFundsExp"
          title="Mutual Funds"
        ></kendo-grid-column>
        <kendo-grid-column field="uitexp" title="UIT"></kendo-grid-column>
        <kendo-grid-column field="etfexp" title="ETF"></kendo-grid-column>
        <kendo-grid-column field="realEstateExp" title="Real Estate">
        </kendo-grid-column>
        <kendo-grid-column field="insExp" title="Insurance">
        </kendo-grid-column>
        <kendo-grid-column field="vaexp" title="Variable Annuities">
        </kendo-grid-column>
        <kendo-grid-column field="fixedAnnExp" title="Fixed Annuities">
        </kendo-grid-column>
        <kendo-grid-column field="precMetExp" title="Precious Metals">
        </kendo-grid-column>
        <kendo-grid-column field="commExp" title="Commodities, Future">
        </kendo-grid-column>
        <kendo-grid-column title="Other">
          <ng-template kendoGridCellTemplate let-column>
            {{ column.otherExpDesc }}<br />{{ column.otherExp }}
          </ng-template>
        </kendo-grid-column>
      </kendo-grid>
    </div>
  `,
    imports: [
        FormsModule,
        ReactiveFormsModule,
        GridComponent,
        KENDO_GRID,
        ColumnComponent,
        CellTemplateDirective,
    ]
})
export class GridReadonlyComponent {
  @Input() field: any = {}
  @Input() form: UntypedFormGroup
  constructor(private ur: ClientServices) {}
}
